/**
 * Polyfill for process.env to handle missing environment variables gracefully
 * This ensures that process.env.REACT_APP_MISSING_VAR returns undefined instead of crashing
 */

// Only add polyfill if process is not defined
if (typeof process === 'undefined') {
    // eslint-disable-next-line
    ;(window as any).process = {
        env: {},
    }
}
